import { render, staticRenderFns } from "./index.vue?vue&type=template&id=652e183c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652e183c')) {
      api.createRecord('652e183c', component.options)
    } else {
      api.reload('652e183c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=652e183c&", function () {
      api.rerender('652e183c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/index.vue"
export default component.exports